import { render, staticRenderFns } from "./Builder.vue?vue&type=template&id=2ca0d0a6&"
import script from "./Builder.vue?vue&type=script&lang=ts&"
export * from "./Builder.vue?vue&type=script&lang=ts&"
import style0 from "./Builder.vue?vue&type=style&index=0&id=2ca0d0a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports